var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import API from "@irati/utils/services/API";
import authentication from "@irati/auth";
import PBService from "@irati/utils/services";
import medicalErrorHandler from "./errors/medicalErrorHandler";
import errorCodes from "../errorCodes";
import getGender from "../helpers/getGender";
import endpoints from "../endpoints";
var MedicalService = /** @class */ (function (_super) {
    __extends(MedicalService, _super);
    function MedicalService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MedicalService.prototype.create = function (medicalUser) {
        var _a = authentication.user(), uuid = _a.uuid, businessId = _a.businessId;
        var email = medicalUser.email, phoneNumber = medicalUser.phoneNumber, gender = medicalUser.gender, dob = medicalUser.dob;
        var data = {
            userId: uuid,
            tenantId: businessId,
            email: email,
            phoneNumber: phoneNumber,
            gender: getGender(gender),
            dateOfBirth: dob
                .split("-")
                .reverse()
                .join("/")
        };
        return API.post(endpoints.create(), data).then(function (res) { return res.data; });
    };
    MedicalService.prototype.getMedicalAccount = function (user, config) {
        if (config === void 0) { config = {}; }
        API.sentryIgnoreError(config, [errorCodes.PBMEDResourceNotFound]);
        return API.get(endpoints.getMedicalAccount(), config).then(function (res) { return res.data; });
    };
    MedicalService.prototype.textMeInstructions = function (user) {
        if (user === void 0) { user = authentication.user(); }
        var data = { userId: user.uuid };
        return API.post("" + endpoints.textMeInstructions(), data).then(function (res) { return res.data; });
    };
    MedicalService.prototype.getStats = function () {
        return API.get(endpoints.getStats()).then(function (res) { return res.data; });
    };
    MedicalService.prototype.getCsv = function (tenantId) {
        return API.get("" + endpoints.getCsv(tenantId)).then(function (res) { return res.data; });
    };
    MedicalService.prototype.resendMedicalWelcomeEmail = function (userUuid) {
        return API.post(endpoints.resendWelcomeEmail(), { userId: userUuid }).then(function (res) { return res.data; });
    };
    return MedicalService;
}(PBService));
var service = new MedicalService({ errorHandlers: [medicalErrorHandler] });
export default service;
export var create = service.create;
export var getMedicalAccount = service.getMedicalAccount;
export var textMeInstructions = service.textMeInstructions;
export var getStats = service.getStats;
export var getCsv = service.getCsv;
export var resendMedicalWelcomeEmail = service.resendMedicalWelcomeEmail;
